var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-tree"},[_c('el-tree',_vm._g(_vm._b({ref:"tree",staticClass:"tree",attrs:{"highlight-current":"","indent":0}},'el-tree',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }